export default "__VITE_ASSET__6915935a__"